import React from 'react';

const AboutContext = React.createContext((source) => {
	return undefined;
});

export default AboutContext;
